import { render, staticRenderFns } from "./couponCodeList.vue?vue&type=template&id=963d5f2c"
import script from "./couponCodeList.vue?vue&type=script&lang=js"
export * from "./couponCodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('963d5f2c')) {
      api.createRecord('963d5f2c', component.options)
    } else {
      api.reload('963d5f2c', component.options)
    }
    module.hot.accept("./couponCodeList.vue?vue&type=template&id=963d5f2c", function () {
      api.rerender('963d5f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/scanCouponCode/couponCodeList.vue"
export default component.exports